import { PayloadAction } from 'typesafe-actions';
import { FavouriteTransfersActionTypes, FavouriteTransfersState } from './types';

const FavouriteTransfersReducer = (
  state: FavouriteTransfersState,
  action: PayloadAction<FavouriteTransfersActionTypes, any>,
): FavouriteTransfersState => {
  switch (action.type) {
    case FavouriteTransfersActionTypes.GetFavouriteTransfers:
      return {
        ...state,
        favouriteTransfersListData: action.payload,
      };

    case FavouriteTransfersActionTypes.SetSelectedFavouriteTransfer:
      return {
        ...state,
        selectedFavouriteTransfer: action.payload.selectedFavouriteTransfer,
        action: action.payload.action,
      };

    case FavouriteTransfersActionTypes.SetFavouriteTransferToEdit:
      return {
        ...state,
        favouriteTransferToEdit: action.payload,
      };

    case FavouriteTransfersActionTypes.SetFavouriteTransferToDelete:
      return {
        ...state,
        favouriteTransferToDelete: action.payload,
      };

    case FavouriteTransfersActionTypes.SetFavouriteTransfersListFilter:
      return {
        ...state,
        favouriteTransfersListFilters: { ...state.favouriteTransfersListFilters, ...action.payload.filters },
        meta: { timestamp: action.payload.timestamp },
      };

    case FavouriteTransfersActionTypes.SetIsFavouriteTransfersFitlerDrawerOpen:
      return {
        ...state,
        isFavouriteTransfersFilterDrawerOpen: action.payload,
      };

    case FavouriteTransfersActionTypes.SetAction:
      return {
        ...state,
        action: action.payload,
      };

    default: {
      return state;
    }
  }
};

export { FavouriteTransfersReducer };
